import {Component, ViewChild, OnInit, ElementRef, AfterViewInit} from '@angular/core';
import {LoginService} from '../../shared/services/login.service';
import {FormControl, Validators} from '@angular/forms';

const emailRE = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})

export class ForgetPasswordComponent implements OnInit, AfterViewInit {

  isRequesting: boolean;
  userId: string;
  validationSummary: string;
  @ViewChild('focusInput') focusInputElement: ElementRef;

  emailControl: FormControl;
  emailControlLength = 50;

  constructor(private loginService: LoginService) {
    this.emailControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.emailControlLength),
      Validators.pattern(emailRE)])
    ]);
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.focusInputElement.nativeElement.focus();
  }

  forgotPassword(): void {
    if (!this.userId || this.userId.trim().length === 0) {
      this.validationSummary = 'Email cannot be empty.';
      return;
    }
    this.isRequesting = true;
    this.loginService.forgotPassword(this.userId).subscribe(ok => {
        this.validationSummary = 'Password reset email has been sent successfully.';
        this.isRequesting = false;
      },
      err => {
        // Log errors if any
        this.isRequesting = false;
        this.validationSummary = err.error.err;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-users/forget-password/forget-password.component.ts